import posthog from 'posthog-js';
import {runningInProdOrDemo} from "../App";

function initializePostHog() {
    if (runningInProdOrDemo()){
        return posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
            api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
            person_profiles: 'identified_only',
            capture_pageview: false
        });
    }
}

function captureEvent() {
    const properties = []
    properties.push('$current_url', window.location.pathname)
    posthog.capture('$pageview', properties);
}

function captureLogoutEvent() {
    const properties = []
    properties.push('$current_url', window.location.pathname)
    posthog.capture('$pageleave', properties, { send_instantly: true });
}


function startPostHog(username) {
    posthog.identify(username)
}

/**
 * A finished signup, mirroring the Google Ads conversion fired from the same call sites
 * (src/analytics/googleAds.js) so both tools count the same moment. `method` tells the two
 * registration paths apart: 'self_register' (form + email confirmation) and 'register_otp'
 * (passwordless code).
 *
 * Gated on the environment here rather than at the call sites, like initializePostHog, so the
 * signup components stay free of analytics conditionals.
 *
 * Note: on the self_register path the user is not logged in yet, so with
 * person_profiles: 'identified_only' this lands as an anonymous event - fine for counting the
 * funnel, but it is not attached to a person profile until that account signs in.
 */
let signupCaptured = false

function captureSignupCompleted(method) {
    // One event per page load. A double-clicked submit or a re-render would otherwise report
    // the signup twice and inflate the funnel.
    if (signupCaptured) return
    if (!runningInProdOrDemo()) return
    signupCaptured = true
    posthog.capture('signup_completed', { method })
}

export { initializePostHog, captureEvent, captureLogoutEvent, startPostHog, captureSignupCompleted };